export const TaskMapColorDot = ({ color, onClick, selected }) => {
  const dotStyle = {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: `rgb(${color})`,
    cursor: "pointer",
    margin: "5px",
    border: "4px solid transparent", // Keep the border size consistent
    boxShadow: selected
      ? "0 0 0 4px rgba(255, 255, 255, 0.6)" // Add an outset border using box-shadow when selected
      : "none",
  };

  return <div style={dotStyle} onClick={onClick}></div>;
};
